<script>
import { patchCompany } from "@/api/locations";

export default {
  name: "email-roi-rules",
  data() {
    return {
      form: {
        days: 14
      }
    };
  },
  methods: {
    async onSubmit() {
      let payload = { roi_days: parseInt(this.form.days) };
      await patchCompany(payload);
      console.log(JSON.parse(JSON.stringify(payload)));
    }
  }
};
</script>

<template>
  <v-card class="mb-10">
    <v-card-title>Email ROI Rules</v-card-title>
    <div class="text-muted p-5">
      Aben watches customer transactions after an email is sent to those
      customers to determine the ROI of an email campaign. Here you can adjust
      how many days to watch for transactions after an email was sent. For
      example, if you select 10 days, Aben would associate the
      <strong>first</strong> transaction for any customer on that email campaign
      as part of the ROI so long as that transaction was within 10 days of the
      email campaign. Note that changing this metric will change the ROI
      calculations for all campaigns.
    </div>
    <div class="p-5">
      <b-form
        v-on:submit.prevent="onSubmit"
        method="POST"
        accept-charset="UTF-8"
        inline
      >
        <b-input-group
          prepend="Days"
          class="mb-2 mr-sm-2 mb-sm-0"
          style="width:200px"
        >
          <b-form-input
            type="number"
            placeholder="Need a valid email address"
            v-model="form.days"
            min="0"
            max="999"
            step="1"
            onkeypress="return event.charCode >= 48 && event.charCode <= 57"
            required
          ></b-form-input>
        </b-input-group>
        <b-button type="submit" variant="primary">Save</b-button>
      </b-form>
    </div>
  </v-card>
</template>
